/**
 * Lap Comparison Module
 *
 * Pre-computes expensive telemetry transformations for lap comparison views.
 * This processor caches coasting detection, time drift calculation, and
 * distance recalibration to avoid recomputing on every render.
 *
 * Used by both web and mobile frontends.
 */

// Types
export type {
  PreprocessedDataPoint,
  PreprocessedLapComparison,
  LapComparisonCache,
  LapComparisonStats,
  LapComparisonProcessorOptions,
  BaseLapDataPoint,
  RecalibrationRefData,
  PreprocessedGradientPoint,
  PreprocessedLapGradient,
  GradientMetricType,
  TimeDriftInterpolation,
} from './types'

// Main preprocessor
export {
  generateLapComparisonCacheKey,
  preprocessLapsForComparison,
} from './preprocessor'

// Statistics
export { calculateComparisonStats } from './statistics'

// Time drift interpolation
export {
  interpolateTimeDrift,
  interpolateTimeDriftWithRate,
} from './timeDriftInterpolation'

// Two-phase processing (for React hooks optimization)
export {
  computeBaseDataPoints,
  applyTimeDriftOverlay,
} from './twoPhaseProcessing'

// Gradient preprocessing
export { preprocessGradientData } from './gradientPreprocessing'
